module.exports = __webpack_public_path__ + "static/img/1.47bff77.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/3/eng/1.png
// module id = Z5zV
// module chunks = 0